import type { User } from "@/context/UserProvider";
import type { PermitSuiteTab } from "@/components/permit_suite/permitSuiteTabs";

export function userHasPermitSuite(user: User | null | undefined): boolean {
  return Boolean(user?.permit_suite);
}

export function userHasPlanReview(user: User | null | undefined): boolean {
  return Boolean(user?.plan_review_access);
}

export function userHasPermitAssistant(user: User | null | undefined): boolean {
  return Boolean(user?.form_extraction_ui);
}

export function canAccessPermitTab(user: User | null | undefined, tab: PermitSuiteTab): boolean {
  switch (tab) {
    case "pipeline":
      return userHasPermitSuite(user);
    case "plan_review":
      return userHasPlanReview(user);
    case "assistant":
      return userHasPermitAssistant(user);
    default: {
      const _exhaustive: never = tab;
      return _exhaustive;
    }
  }
}

const PERMIT_TAB_FALLBACK_ORDER: PermitSuiteTab[] = ["pipeline", "plan_review", "assistant"];

/**
 * A tab the user can actually open, for callers (action alerts, deep links)
 * that request a specific tab the user's flags may deny. Returns null when
 * the user has none of the three permitting flags.
 */
export function nearestAccessiblePermitTab(user: User | null | undefined): PermitSuiteTab | null {
  return PERMIT_TAB_FALLBACK_ORDER.find((tab) => canAccessPermitTab(user, tab)) ?? null;
}
